<div [ngClass]="props.btnWrapperClass">
  <button [type]="props.type"
    [ngClass]="'btn ' + props.btnClass"
    (click)="onClick($event)"
    [disabled]="props.disabled">
    @if (props.icon) {
      <fa-icon [icon]="['fas', props.icon]"
        transform="shrink-3"
        [fixedWidth]="true"
        >
      </fa-icon>
    }
    @if (props.text) {
      <span>{{ props.text }}</span>
    }
  </button>
</div>
